/** Erreur racine du domaine : porte un code HTTP exploitable par la présentation. */
export class DomainError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(message: string, status = 500, code = 'DOMAIN_ERROR') {
    super(message);
    this.name = new.target.name;
    this.status = status;
    this.code = code;
  }
}

/** 400 — payload invalide. */
export class ValidationError extends DomainError {
  readonly fields: Readonly<Record<string, string>>;

  constructor(message = 'Données invalides', fields: Record<string, string> = {}) {
    super(message, 400, 'VALIDATION_ERROR');
    this.fields = fields;
  }
}

/** 401 — non authentifié / session expirée. */
export class UnauthenticatedError extends DomainError {
  constructor(message = 'Session expirée, reconnectez-vous.') {
    super(message, 401, 'UNAUTHENTICATED');
  }
}

/** 403 — authentifié mais droits insuffisants (RBAC). */
export class ForbiddenError extends DomainError {
  constructor(message = 'Réservé au super-admin') {
    super(message, 403, 'FORBIDDEN');
  }
}

/** 404 — ressource absente. */
export class NotFoundError extends DomainError {
  constructor(resource: string, id: string) {
    super(`${resource} introuvable (${id})`, 404, 'NOT_FOUND');
  }
}

/** 409 — conflit d'état (double soumission, statut incompatible). */
export class ConflictError extends DomainError {
  constructor(message = 'Opération impossible dans cet état.') {
    super(message, 409, 'CONFLICT');
  }
}

/** 5xx / réseau. */
export class InfrastructureError extends DomainError {
  constructor(message = 'Erreur réseau, réessayez.', status = 503) {
    super(message, status, 'INFRASTRUCTURE_ERROR');
  }
}

export function isDomainError(error: unknown): error is DomainError {
  return error instanceof DomainError;
}

/** Normalise n'importe quelle exception en DomainError (jamais de throw brut côté UI). */
export function toDomainError(error: unknown): DomainError {
  if (isDomainError(error)) return error;
  if (error instanceof Error) return new DomainError(error.message);
  return new DomainError('Erreur inattendue.');
}
